export const obtenerTotal = (prods) => {

    if (!prods || prods.length === 0) {
        return 0
    }

    let valor = 0
    for (let i = 0; i < prods.length; i++) {
        valor += prods[i].valor * prods[i].cantidad
    }

    return valor
}